import type { CityConfig } from "@/pages/city-template/types";

export const annArborConfig: CityConfig = {
  city: "Ann Arbor",
  state: "Michigan",
  stateAbbr: "MI",
  slug: "ann-arbor",
  route: "/cities/ann-arbor",
  title: "Emergency Passport Ann Arbor, MI — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Ann Arbor, Michigan — as fast as 24 hours. Fast passport renewal and new passport applications for Ann Arbor, Ypsilanti, Chelsea, Saline, and Washtenaw County residents. University of Michigan travel. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Ann Arbor, MI",
  heroSubtitle: "Ann Arbor travelers — from University of Michigan researchers and faculty to tech professionals and international families — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. Detroit Passport Agency is only 30 miles away. A+ BBB rated courier service serving all of Washtenaw County.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Beautiful%20view%20of%20Ann%20Arbor%20Michigan%20with%20University%20of%20Michigan%20campus%20architecture%20in%20the%20foreground%2C%20Law%20Quad%20gothic%20stone%20buildings%2C%20tree-canopied%20streets%20with%20vibrant%20autumn%20colors%2C%20warm%20golden%20hour%20light%2C%20college%20town%20atmosphere%20with%20majestic%20historic%20buildings%2C%20no%20text%20no%20people%2C%20stunning%20architectural%20photography&width=1800&height=700&seq=ann-arbor-hero-2026&orientation=landscape",
  heroImageAlt: "Ann Arbor Michigan University of Michigan campus with gothic architecture and autumn trees",
  geoPosition: "42.2808;-83.7430",
  geoPlacename: "Ann Arbor, Michigan",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Detroit Passport Agency",
    address: "230 S Dearborn St Suite 380, Chicago IL 60604",
    distance: "Approximately 240 miles, 3.5 hours via I-94",
  },
  nearbyCitiesZips: [
    { name: "Ann Arbor", zips: "48103, 48104, 48105, 48106, 48107, 48108, 48109" },
    { name: "Ypsilanti", zips: "48197, 48198" },
    { name: "Saline", zips: "48176" },
    { name: "Chelsea", zips: "48118" },
    { name: "Dexter", zips: "48130" },
    { name: "Manchester", zips: "48158" },
    { name: "Milan", zips: "48160" },
    { name: "Ypsilanti Township", zips: "48198" },
    { name: "Pittsfield Township", zips: "48108, 48197" },
    { name: "Scio Township", zips: "48103, 48130" },
    { name: "Lodi Township", zips: "48130, 48176" },
    { name: "Salem Township", zips: "48175" },
    { name: "Whitmore Lake", zips: "48189" },
    { name: "South Lyon", zips: "48178" },
    { name: "Brighton", zips: "48114, 48116" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier — Detroit agency only 30–45 min from Ann Arbor" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-book-line", title: "University Research Support", desc: "Serving UM faculty, researchers, students and international travel" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — no trip to downtown Detroit required" },
  ],
  testimonials: [
    {
      name: "Dr. Chen W.",
      location: "University of Michigan, Ann Arbor",
      rating: 5,
      text: "International conference in Singapore in 5 days and my passport had 4 months left — not enough. Fast Passport Center renewed it in under 48 hours. Being close to the Detroit agency made all the difference. My couriers arrived before I even knew they left.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Emily R.",
      location: "Ann Arbor, MI",
      rating: 5,
      text: "Study abroad in Spain — realized I needed to renew my passport two weeks before departure. Fast Passport Center handled everything. Passport arrived in 4 days. My parents are in Saline and they couldn't believe how easy it was.",
      service: "Passport Renewal",
    },
    {
      name: "Tom & Jessica A.",
      location: "Ypsilanti, MI",
      rating: 5,
      text: "Honeymoon to Italy and both our passports were expiring. Renewed both in 3 days, shipped from the UPS near campus. Absolutely seamless. Used Fast Passport Center because a UM colleague recommended them.",
      service: "Couple Passport Renewal",
    },
    {
      name: "Prof. Sarah M.",
      location: "Ann Arbor, MI",
      rating: 5,
      text: "UM sabbatical in London — needed an expedited passport with new last name after marriage. Fast Passport Center walked me through DS-5504 and had my name-change passport in 3 days. Couldn't be more grateful.",
      service: "Name Change Passport",
    },
  ],
  facilities: [
    {
      id: "aa-1",
      name: "Ann Arbor Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2075 W Stadium Blvd",
      city: "Ann Arbor",
      state: "MI",
      zip: "48103",
      phone: "(734) 996-8200",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "West Ann Arbor, near Stadium and Maple",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Ann Arbor acceptance facility. Appointments required — book 1–2 weeks in advance. Near the University of Michigan medical complex and west campus.",
      icon: "ri-mail-line",
    },
    {
      id: "aa-2",
      name: "Ann Arbor Downtown Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "220 N 4th Ave",
      city: "Ann Arbor",
      state: "MI",
      zip: "48104",
      phone: "(734) 662-8977",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Ann Arbor, near Main Street",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Downtown Ann Arbor location. Convenient to campus, tech offices, and Main Street businesses. Parking available nearby. Walk-ins sometimes accepted during non-peak hours.",
      icon: "ri-mail-line",
    },
    {
      id: "aa-3",
      name: "Ypsilanti Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "34 N Washington St",
      city: "Ypsilanti",
      state: "MI",
      zip: "48197",
      phone: "(734) 485-2840",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Ypsilanti, approximately 7 miles east of Ann Arbor",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Ypsilanti and Eastern Michigan University area residents. Good alternative when Ann Arbor appointments are full.",
      icon: "ri-mail-line",
    },
    {
      id: "aa-4",
      name: "Saline Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "100 N Harris St",
      city: "Saline",
      state: "MI",
      zip: "48176",
      phone: "(734) 429-7630",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Saline, approximately 10 miles south of Ann Arbor",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Saline, Milan, and southern Washtenaw County residents. Free parking available.",
      icon: "ri-mail-line",
    },
    {
      id: "aa-5",
      name: "Chelsea Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "305 S Main St",
      city: "Chelsea",
      state: "MI",
      zip: "48118",
      phone: "(734) 475-1511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Chelsea, approximately 15 miles west of Ann Arbor",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Chelsea, Dexter, and western Washtenaw County residents. Call to confirm current passport hours.",
      icon: "ri-mail-line",
    },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Ann Arbor, MI?", a: "Fast Passport Center offers emergency passport processing in Ann Arbor, Michigan in as little as 24–48 hours. Because Ann Arbor is only 30–45 minutes west of the Detroit Passport Agency via I-94, our couriers can deliver and receive same-day — making Ann Arbor one of the fastest locations in Michigan for emergency passport processing." },
    { q: "Does Ann Arbor have its own passport agency?", a: "No — Ann Arbor does not have a regional passport agency. The Detroit Passport Agency (477 Michigan Ave 3rd Floor, Detroit, MI 48226) is only 30–45 minutes east via I-94. Fast Passport Center's couriers have direct access to the Detroit agency — Ann Arbor residents don't need to drive or wait for an appointment." },
    { q: "Can University of Michigan students and faculty get expedited passports?", a: "Yes. Fast Passport Center frequently serves UM faculty, researchers, and staff with urgent international travel needs. Whether it's a last-minute conference in Europe or a research trip to Asia, our courier service delivers passports in 24–48 hours for emergency cases. We understand academic travel timelines." },
    { q: "Can I get an expedited passport in Ypsilanti, Chelsea, or Saline?", a: "Absolutely. Fast Passport Center serves all of Washtenaw County including Ypsilanti, Saline, Chelsea, Dexter, Manchester, Milan, Pittsfield Township, and all surrounding communities. Our service works the same everywhere — complete online, ship documents, we handle the rest." },
    { q: "What airports do Ann Arbor travelers use for international flights?", a: "Ann Arbor residents primarily use Detroit Metro Wayne County Airport (DTW) in Romulus, approximately 20–25 minutes southeast via US-23 and I-94. DTW is a Delta hub with direct routes to London, Amsterdam, Tokyo, Paris, and many other international cities. Toledo Express (TOL) is another option for budget domestic connections." },
    { q: "How much does an expedited passport cost in Ann Arbor, MI?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos near the University of Michigan?", a: "Walgreens near State Street, CVS on Washtenaw, the UPS Store on Plymouth Road, and the UM Student Union photo services all offer passport photos. Photos must be 2x2 inches on a white background, taken within 6 months." },
    { q: "Do foreign nationals at UM need a US passport?", a: "No — US passports are only for US citizens. Foreign nationals at the University of Michigan travel on their home country passport and typically need a US visa for re-entry. If you are a US citizen who attended UM and need a first passport or renewal, we can help." },
    { q: "Can I use a passport card for Canada crossings from Ann Arbor?", a: "Yes — the passport card is a great option for Ann Arbor and Washtenaw County residents who regularly cross into Windsor, Ontario (just an hour away via the Ambassador Bridge or Detroit-Windsor Tunnel). The passport card is wallet-size and valid for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean. Note: passport cards are NOT valid for international air travel." },
  ],
  photoLocations: [
    { name: "Walgreens — State Street Ann Arbor", address: "328 S State St, Ann Arbor, MI 48104", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/" },
    { name: "CVS Pharmacy — Washtenaw Ave", address: "2745 Washtenaw Ave, Ann Arbor, MI 48104", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "UPS Store — Plymouth Road", address: "2600 Plymouth Rd, Ann Arbor, MI 48105", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM", website: "https://www.theupsstore.com/" },
    { name: "Meijer — Washtenaw Ave", address: "3145 Ann Arbor-Saline Rd, Ann Arbor, MI 48108", hours: "Mon–Sun: 6AM–Midnight", website: "https://www.meijer.com/" },
    { name: "FedEx Office — Ann Arbor", address: "2455 S Industrial Hwy, Ann Arbor, MI 48104", hours: "Mon–Fri: 8AM–6PM, Sat: 9AM–5PM", website: "https://www.fedex.com/" },
    { name: "CVS Pharmacy — Ypsilanti", address: "1779 Washtenaw Rd, Ypsilanti, MI 48197", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
  ],
  dmvLocations: [
    { name: "Michigan SOS — Ann Arbor", address: "3773 Plaza Dr, Ann Arbor, MI 48108", hours: "Mon–Fri: 9:00AM–5:00PM", note: "Michigan Secretary of State for driver's licenses, REAL ID, and vehicle registration. Online reservations strongly recommended for all services.", featured: true },
    { name: "Michigan SOS — Ypsilanti", address: "119 Pearl St, Ypsilanti, MI 48197", hours: "Mon–Fri: 9:00AM–5:00PM", note: "Serves Ypsilanti and eastern Washtenaw County. Good alternative when Ann Arbor is fully booked.", featured: false },
  ],
  airports: [
    {
      code: "DTW",
      name: "Detroit Metro Wayne County Airport",
      distance: "20–25 minutes southeast of Ann Arbor via US-23 and I-94",
      address: "1 Detroit Metro Airport, Romulus, MI 48242",
      note: "Primary international airport for Ann Arbor travelers. Delta hub with direct flights to London, Amsterdam, Tokyo, Paris, Mexico City, and 40+ international destinations.",
      flightUrl: "https://www.metroairport.com/",
      flightLabel: "DTW Flight Info",
      featured: true,
    },
    {
      code: "YYZ",
      name: "Toronto Pearson International Airport",
      distance: "Approximately 3.5–4 hours north via I-94 and Ambassador Bridge",
      address: "6301 Silver Dart Dr, Mississauga, ON L5P 1B2, Canada",
      note: "Alternative for Ann Arbor travelers seeking more international routes or competitive fares on Air Canada. Requires a valid passport for the Canada crossing.",
      flightUrl: "https://www.torontopearson.com/",
      flightLabel: "Pearson Airport Info",
      featured: false,
    },
    {
      code: "TOL",
      name: "Toledo Express Airport",
      distance: "50 minutes southwest of Ann Arbor via US-23 and I-475",
      address: "11013 Airport Hwy, Swanton, OH 43558",
      note: "Small regional airport with limited domestic routes. Sometimes used for connections but DTW is far superior for most Ann Arbor international travel.",
      flightUrl: "https://www.toledoexpress.com/",
      flightLabel: "TOL Airport Info",
      featured: false,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Ann Arbor travelers with immediate departure needs — as fast as 24 hours. Detroit Passport Agency is only 30–45 minutes from Ann Arbor via I-94, making our courier service especially fast for Washtenaw County residents.",
      bullets: ["24–48 hour turnaround available", "Detroit agency 30–45 min from Ann Arbor", "Academic conference and research travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Ann Arbor adults with a passport issued within the last 15 years. Perfect for UM faculty and staff with conference travel.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Ann Arbor address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Ann Arbor residents and UM students — including international graduate students seeking US passports and local families.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Ann Arbor and Washtenaw County residents who lost their passport before international travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Ann Arbor and Ypsilanti families planning international travel.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Ann Arbor and Washtenaw County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for UM researchers with simultaneous visa applications, frequent flyers, and Ann Arbor tech professionals traveling internationally while their primary passport is in visa processing.",
      bullets: ["Frequent traveler solution", "Backup during visa processing", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a water-damaged, torn, or significantly worn passport faster than you think. Common for Ann Arbor travelers who discover damage right before an international conference or research trip.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The wallet-size passport card is perfect for Ann Arbor residents who regularly cross into Windsor, Ontario — just an hour east via I-94. Valid for land and sea crossings to Canada, Mexico, Bermuda, and the Caribbean.",
      bullets: ["Wallet-size convenience", "Land crossings to Canada", "Same expedited processing as book"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Ann Arbor MI", description: "Urgent passport processing for Ann Arbor Michigan travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Ann Arbor MI", description: "Fast passport renewal for Ann Arbor Michigan residents with a previously-issued passport." },
    { name: "First-Time Passport Ann Arbor MI", description: "New passport application services for Ann Arbor Michigan residents applying for their first passport." },
    { name: "Child Passport Ann Arbor MI", description: "Minor passport services for Ann Arbor Michigan families with children under 16." },
    { name: "Second Passport Ann Arbor MI", description: "Second passport services for Ann Arbor researchers, frequent flyers, and international business travelers." },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Conference Is Confirmed",
      description: "UM researchers and faculty often wait until international conferences are confirmed before renewing passports — leaving weeks, not months. Routine processing takes 6–13 weeks. Start expedited service immediately after booking.",
    },
    {
      icon: "ri-file-list-line",
      title: "Not Checking 6-Month Validity",
      description: "Most countries require your passport to be valid for at least 6 months past your return date. A passport expiring in 4 months is considered invalid for most international travel. This catches UM faculty and international researchers off-guard constantly.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo shops sometimes produce photos that meet ID requirements but fail passport standards. Photos must be exactly 2x2 inches on a plain white background — no shadows, no smiling, no glasses.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Booking Acceptance Facilities Early",
      description: "Ann Arbor Post Office appointments fill quickly, especially near the start and end of semesters when UM students and faculty are preparing for study abroad and conference travel. Book 2–3 weeks ahead.",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport Requirements",
      description: "First-time child passports require both parents present at the acceptance facility. This is a common surprise for busy UM families. Plan ahead and book the appointment well in advance.",
    },
    {
      icon: "ri-global-line",
      title: "Ignoring International Student Visa Overlap",
      description: "International students returning to home countries for visits need to ensure their US visa allows re-entry. A passport renewal does not affect your US visa — it remains valid in your old passport.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere on or off the University of Michigan campus." },
    { number: "02", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at the UPS Store near campus or any FedEx in Ann Arbor." },
    { number: "03", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "04", icon: "ri-passport-line", title: "Processing", description: "Our registered courier delivers to the Detroit Passport Agency (30–45 min away) — no appointment wait required." },
    { number: "05", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Ann Arbor address — trackable every step of the way." },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Direct access to Detroit Passport Agency", "Ann Arbor proximity = fastest in Michigan", "Perfect for academic and research travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Direct access to Detroit Passport Agency", "Faster than self-service", "Good for planned academic travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Detroit Passport Agency (Self-Service)",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — typically 2 weeks out", "Life-or-death emergencies only", "Must appear in person in downtown Detroit", "30–45 min drive — plus parking and wait time"],
      highlight: false,
      emergency: true,
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — typically 2 weeks out at Chicago", fpc: "No — we handle Chicago agency submission" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 240-mile drive to Chicago via I-94", fpc: "No — ship from Ann Arbor" },
    { feature: "Academic Travel Support", agency: "No flexibility for conference needs", fpc: "Yes — we handle research and academic cases" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
    { feature: "UM/Washtenaw Expertise", agency: "No — generic service", fpc: "Yes — built-in UM and academic travel knowledge" },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Ann Arbor Residents",
    intro: "Ann Arbor's unique position as a world-class university town with a major international airport nearby creates distinct passport timing challenges. Here's what Washtenaw County travelers need to know.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "DTW — Detroit Metro Airport",
        subtitle: "Delta Air Lines hub, 20–25 minutes from Ann Arbor",
        description: "DTW is remarkably close to Ann Arbor — just a quick drive down I-94. As a major Delta hub, DTW offers direct flights to London, Amsterdam, Tokyo, Paris, Shanghai, Seoul, and dozens of other international destinations. The McNamara Terminal is one of the best-designed airport terminals in the country, with an indoor express tram and abundant amenities. For Ann Arbor travelers, DTW's proximity means you can leave campus at 4 PM and be through security by 4:30 PM for an evening international flight.",
        tip: "Delta's international flights from DTW often have premium cabin award availability at competitive rates. Check your passport validity the moment you book — especially for Asia flights requiring 6+ months validity beyond return.",
      },
      {
        icon: "ri-flight-takeoff-line",
        title: "Windsor Cross-Border Travel",
        subtitle: "Canada is literally an hour away via the Detroit-Windsor Tunnel",
        description: "Ann Arbor's proximity to Windsor, Ontario is a unique asset. Windsor is just an hour east — a quick day trip for dim sum, casino visits, or connecting to VIA Rail for Toronto and Montreal. Many UM faculty and students cross the border regularly for conferences at the University of Windsor, research collaborations, or leisure trips to Toronto (4 hours). The passport card is perfect for these land crossings — it lives in your wallet and costs less than a passport book.",
        tip: "The Windsor-Detroit border crossing is one of the busiest in North America. Always carry your passport or passport card. Enhanced driver's licenses also work for land crossings, but Michigan's REAL ID is NOT an enhanced license — don't confuse the two.",
      },
      {
        icon: "ri-graduation-cap-line",
        title: "UM Academic & Research Travel",
        subtitle: "One of the world's great research universities",
        description: "The University of Michigan generates an enormous volume of international travel. Faculty present at conferences from Berlin to Beijing. Researchers collaborate at CERN in Geneva, the Max Planck Institute in Germany, and partner universities across six continents. Graduate students conduct fieldwork from the Amazon to the Arctic. Post-docs and visiting scholars rotate through Ann Arbor constantly. This creates a year-round stream of passport urgencies — newly hired faculty who never had passports, researchers with expiring passports discovered days before travel, and international collaborations with inflexible dates.",
        tip: "UM's International Center provides excellent resources for travel documentation, but they cannot expedite passports. Start passport applications at least 10-12 weeks before any confirmed international travel, even if the trip is tentative. The Detroit agency's proximity helps tremendously for last-minute emergencies.",
      },
      {
        icon: "ri-building-2-line",
        title: "Ann Arbor Tech & Startup Travel",
        subtitle: "Google, Duo Security, Toyota Research, and the Ann Arbor startup ecosystem",
        description: "Ann Arbor's tech corridor — anchored by Google's large office, Duo Security (now Cisco), Toyota Research Institute, and dozens of venture-backed startups — creates regular international business travel. Founders flying to London for investor meetings, engineers traveling to Tokyo for Toyota collaboration, and sales teams heading to European tech conferences. These trips are often booked with 1-2 weeks notice, creating a constant flow of expedited passport needs.",
        tip: "Ann Arbor tech companies with global operations should maintain a running passport validity check for employees with international travel responsibilities. A second passport is often worthwhile for frequent travelers whose primary passport is frequently in visa processing.",
      },
    ],
    callout: {
      icon: "ri-global-line",
      title: "The International Student & Scholar Pipeline",
      description: "UM's international student population — over 8,000 students from 130+ countries — creates a unique dynamic. While international students travel on their home country passports, their US-born children need US passports. Additionally, faculty with international backgrounds frequently need expedited passport services when naturalizing as US citizens and planning their first trip abroad with a US passport.",
    },
  },
  destinations: {
    title: "Where Ann Arbor Travelers Go — And Why Passports Get Urgent",
    intro: "UM's global reach, DTW's international routes, and Washtenaw County's diverse community shape the destinations that create the most passport urgency.",
    stats: [
      { stat: "45%", label: "of Ann Arbor expedited requests are academic or research-related — conferences, fieldwork, collaborations" },
      { stat: "1–2 Weeks", label: "average lead time for UM faculty conference travel from acceptance to departure" },
      { stat: "Mar–May", label: "peak season when spring conferences, graduation trips, and summer research deployments collide" },
      { stat: "3,000+", label: "UM faculty and graduate students travel internationally each year for academic purposes" },
    ],
    destinations: [
      { name: "United Kingdom", context: "London for academic conferences, Oxford/Cambridge collaborations, and DTW-London Heathrow direct flights. UM's strong humanities and social sciences ties to UK institutions drive heavy travel.", urgency: "Conference acceptances often come 4-6 weeks out — tight timeline for passport renewal", icon: "ri-map-pin-2-line" },
      { name: "Germany", context: "Max Planck Institute collaborations, auto industry research partnerships (Toyota, automotive engineering), Berlin startup scene, and DTW-Frankfurt direct flights.", urgency: "Research collaborations with fixed dates — no flexibility on passport timing", icon: "ri-map-pin-2-line" },
      { name: "Japan & South Korea", context: "Toyota Research Institute collaborations, UM Center for Japanese Studies, DTW-Tokyo direct flights, and strong engineering partnerships.", urgency: "Business trips often booked 1-2 weeks out — need 6+ months validity on passport", icon: "ri-map-pin-2-line" },
      { name: "Canada", context: "Windsor day trips, Toronto conferences, Montreal research, Vancouver collaborations. The closest international destination — just an hour to the border.", urgency: "Passport card ideal for land crossings; many residents discover expired passports right before a Windsor trip", icon: "ri-map-pin-2-line" },
      { name: "France & Netherlands", context: "DTW-Amsterdam and DTW-Paris direct flights. Strong UM European studies programs, art history research, and engineering partnerships at TU Delft.", urgency: "Summer research programs with fixed start dates — no flexibility", icon: "ri-map-pin-2-line" },
      { name: "China", context: "DTW-Shanghai and DTW-Beijing direct flights. UM has one of the largest Chinese international student populations and strong research ties with Chinese universities.", urgency: "Visa processing times are long — second passport often needed while primary is in visa queue", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other Michigan Service Areas",
    crossLinksDesc: "We serve travelers across the Great Lakes State with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Detroit", route: "/detroit" },
      { name: "Michigan Overview", route: "/michigan" },
    ],
  },
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified Michigan birth certificates from the MDHHS Vital Records office. Available by mail, online, or in person at the Lansing office. Required for first-time passport applications.",
      url: "https://www.michigan.gov/mdhhs/adult-child-serv/informedconsent/vitalrecords",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through the Michigan Department of Health and Human Services Vital Records division. Required for estate and legal matters in Washtenaw County.",
      url: "https://www.michigan.gov/mdhhs/adult-child-serv/informedconsent/vitalrecords",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request certified marriage certificates from the Washtenaw County Clerk. Marriage licenses are issued by the county clerk where the license was obtained.",
      url: "https://www.washtenaw.org/clerk",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Washtenaw County Clerk. Required for name change passport corrections after divorce.",
      url: "https://www.washtenaw.org/clerk",
    },
  ],
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  internalLinks: [
    { name: "Expedited passport in Ypsilanti, MI", route: "/michigan" },
    { name: "Emergency passport help in Detroit, MI", route: "/detroit" },
    { name: "Urgent passport services in Chelsea, MI", route: "/michigan" },
    { name: "Michigan passport services overview", route: "/michigan" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Ann Arbor, Michigan via secure registered courier with the advantage of proximity to the Detroit Passport Agency (only 30–45 minutes east via I-94). Our registered couriers hand-deliver your documents to the Detroit agency — meaning Ann Arbor residents get some of the fastest turnaround times in Michigan.",
  fpcOfficeAddress: "230 S Dearborn St Suite 380, Chicago IL 60604",
  fpcOfficeDistance: "Serving Ann Arbor, Ypsilanti, Saline, Chelsea, Dexter, Pittsfield, and all of Washtenaw County",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Ann Arbor and Washtenaw County. From the University of Michigan campus and medical complex to the tech corridor near Plymouth Road, from the charming downtown on Main Street to the surrounding communities of Ypsilanti, Chelsea, and Saline — we serve all of Washtenaw County and surrounding areas.",
  nearbyCitiesIntro: "We serve Ann Arbor and all nearby communities including Ypsilanti, Saline, Chelsea, Dexter, Manchester, Milan, Pittsfield Township, Scio Township, Whitmore Lake, South Lyon, and Brighton. We also serve Livingston County and eastern Washtenaw County communities.",
  howItWorksIntro: "Most Ann Arbor travelers complete everything online and ship documents overnight. Ann Arbor's proximity to the Detroit Passport Agency (only 30–45 minutes via I-94) means some of the fastest emergency passport processing in Michigan.",
  mistakesIntro: "Ann Arbor is a highly educated, internationally mobile community with constant travel to and from the University of Michigan. Here are the most common passport mistakes we see from Washtenaw County travelers.",
  testimonialsIntro: "Ann Arbor travelers — from UM researchers to tech professionals to families — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Ann Arbor, MI? Here are the most common ones we hear from Washtenaw County travelers.",
  statePageRoute: "/states/michigan",
  statePageName: "Michigan",
  dmvWebsite: "https://www.michigan.gov/sos",
  dmvLabel: "Michigan SOS — Official Website",
};

export default annArborConfig;